<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Configurazioni', route: '/backoffice/configurazioni/' }, { label: 'Aggiungi Configurazione', route: '/backoffice/configurazioni/add' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Aggiungi configurazione</h1>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formConfigurazione" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <h2>Dati configurazione</h2>
            <span class="ac-meta">valore e descrizione opzionale</span>
        </div>

        <div class="fld">
            <label>* Valore</label>
            <input type="text" pInputText class="w-full" formControlName="value" name="value" id="value" required />
            <small class="text-red-600 block mt-2 font-medium" *ngIf="formConfigurazione.get('value')?.hasError('required') && (formConfigurazione.get('value')?.dirty || formConfigurazione.get('value')?.touched)">Il valore è obbligatorio.</small>
        </div>

        <div class="fld">
            <label>Descrizione <span class="ac-meta">(opzionale)</span></label>
            <input type="text" pInputText class="w-full" formControlName="descrizione" name="descrizione" id="descrizione" />
        </div>

        <div class="acc-actions">
            <a class="acc-btn acc-btn-ghost" routerLink="/backoffice/configurazioni">Annulla</a>
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formConfigurazione.valid">Aggiungi configurazione</button>
        </div>
    </form>
</section>
